'use client';

import { HTMLMotionProps, motion } from 'framer-motion';
import { memo, PropsWithChildren } from 'react';

type Props = PropsWithChildren<{
    className?: string;
    motionProps?: HTMLMotionProps<'div'>;
}>;

function PageWrapper({ children, className, motionProps }: Props) {
    return (
        <motion.div
            {...motionProps}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 20 }}
            className={`wapper-animate ${className ?? ''}`}
        >
            {children}
        </motion.div>
    );
}

export default memo(PageWrapper);
